<template>
  <div class="drivers__chart-container">
    <template v-if="!error && chartData && Object.keys(chartData).length">
      <p class="drivers__chart-desc">
        <VisibleText>To compute this driver we used:</VisibleText>
        <Tooltip
          class="drivers__info"
          :text-visible="isInfoTooltipOpen"
          @close="isInfoTooltipOpen = false"
        >
          <template #title>
            <button class="drivers__regression-btn" @click="isInfoTooltipOpen = true">
              {{
                chartData.estimator_name
                  ? chartData.estimator_name.replace(/_/g, ' ')
                  : 'regression'
              }}
              <SvgIconDecorative icon="info" class="drivers__regression-btn-icon" title="details" />
            </button>
          </template>
          <VisibleText>How is drivers analysis computed?</VisibleText>
          <p class="drivers__info-text">{{ chartData.estimator_summary }}</p>
        </Tooltip>
        {{ chartData.dynamic_summary.drivers_summary }}
        <VisibleText
          >The following chart shows each driver and their relative importance to each other.
        </VisibleText>
      </p>
      <DriversChart type="HorizontalBarChart" :chart-node="chartNode" :key="chartNodeKey" />
      <div v-if="hasSampleSizeError" style="margin-left: 2rem">
        <p>
          <VisibleText
            >Warning. Some of the results have too low a response rate for drivers analysis and have
            been excluded.</VisibleText
          >
        </p>
      </div>
      <div v-if="!skipMatrix">
        <!-- hiding until optimized -->
        <!-- <p class="drivers__chart-desc">
          {{ chartData.dynamic_summary.priority_matrix_summary }}
        </p> -->
        <DriversChart type="PriorityMatrix" :chart-node="matrixNode" :key="matrixNodeKey" />
      </div>
    </template>
    <template v-else>
      <p class="error-msg__inline" style="text-align: center; width: 100%">
        {{ errorMsg }}
      </p>
    </template>
  </div>
</template>

<script>
// Components
import DriversChart from './DriversChart.vue';
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import Tooltip from '@/components/UI/Tooltip.vue';

// Helper
import { PigeonDocNodeModel } from '@/pigeondoc/wrapper';
import { driversChart as driversChartNode } from '@/components/Reports/Utils/Library/Drivers/driversNodes.js';
import { priorityMatrixChart } from '@/components/Reports/Utils/Library/Drivers/priorityMatrixNodes.js';

export default {
  name: 'DriversCharts',
  props: {
    dependentVariableTitle: {
      default: () => 'Overall Satisfaction',
      type: String,
    },
    chartData: {
      type: [Object, Number],
      default: () => {},
    },
    skipMatrix: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    DriversChart,
    SvgIconDecorative,
    Tooltip,
  },
  data() {
    return {
      chartNode: null,
      chartNodeKey: 0,
      error: false,
      errorMsg: null,
      matrixNode: null,
      matrixNodeKey: 1,
      isInfoTooltipOpen: false,
    };
  },
  computed: {
    language() {
      return this.$store.getters['getLanguage'];
    },
    hasSampleSizeError() {
      if (this.chartData.time_series_scores) {
        for (let x = 0; x < this.chartData.time_series_scores.length; x++) {
          if (this.chartData.time_series_scores[x]['estimator_name'] == 'SampleSizeError') {
            return true;
          }
        }
      }

      return false;
    },
  },
  watch: {
    chartData: {
      immediate: true,
      handler() {
        if (this.chartData && this.chartData.err) {
          this.error = true;
          if (this.chartData.errObj.status === 424) {
            this.errorMsg =
              'Error:   Drivers analysis only accepts questions with scale, ' +
              'category or numeric data types';
          } else if (this.chartData.errObj.status === 422) {
            this.errorMsg = `Error: The sample size is too low. ${this.chartData.errObj.data}`;
          } else if (this.chartData.errObj.status) {
            this.errorMsg = `Error: ${this.chartData.errObj.data}`;
          } else {
            this.errorMsg = 'Error: There was an error with drivers analysis. Please try again.';
          }
        } else if (this.chartData && Object.keys(this.chartData).length) {
          this.error = false;
          this.errorMsg = null;
          this.chartNode = new PigeonDocNodeModel(
            driversChartNode(this.dependentVariableTitle, this.chartData, false, this.language),
          );
          this.matrixNode = new PigeonDocNodeModel(
            priorityMatrixChart(this.dependentVariableTitle, this.chartData, false, this.language),
          );

          // update they key so it re-renders the charts
          this.chartNodeKey += 1;
          this.matrixNodeKey += 1;
        }
      },
    },
  },
};
</script>
